import React from 'react';
import './SignUpSection.css';

const SignUpSection = () => {
  return (
    <section id="signup" className="section signup-section">
      <div className="signup-card">
        <img src="/assets/icon.png" alt="Panacea Logo" className="signup-logo" />
        <h2 className="signup-title">Get Early Access</h2>
        <p className="signup-subtitle">
          Join the waitlist to try precision monitoring with real patients.
        </p>

        {/* Connects directly to Formspree */}
        <form
          className="signup-form"
          action="https://formspree.io/f/xandjpgd"
          method="POST"
        >
          <div className="form-row">
            <label htmlFor="name">Full name</label>
            <input id="name" name="name" type="text" placeholder="Jane Doe" required />
          </div>

          <div className="form-row">
            <label htmlFor="email">Work email</label>
            <input id="email" name="email" type="email" placeholder="jane@clinic.org" required />
          </div>

          <div className="form-row">
            <label htmlFor="role">Role</label>
            <select id="role" name="role" defaultValue="Clinician" required>
              <option>Clinician</option>
              <option>Care Coordinator</option>
              <option>Researcher</option>
              <option>Administrator</option>
              <option>Other</option>
            </select>
          </div>

          <div className="form-row">
            <label htmlFor="org">Organization (optional)</label>
            <input id="org" name="organization" type="text" placeholder="Riverbend Health" />
          </div>

          <button className="primary-button signup-submit" type="submit">
            Request Access
          </button>

          <p className="signup-privacy">
            We’re HIPAA-conscious by design. No spam—ever.
          </p>
        </form>
      </div>
    </section>
  );
};

export default SignUpSection;
